/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import 'moment/locale/pt-br';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useSelector } from 'react-redux';
import { Container } from './styles';

interface MyHistoryModalProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const MyHistoryModal = ({ showModal, setShowModal }: MyHistoryModalProps) => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  return (
    <Container>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 shadow-lg p-5"
      >
        <div className="p-5 text-center">
          <h5 className="fw-bold mb-3">
            Não localizamos informações sobre a empresa{' '}
            <span className="font-weight-bold">{profile?.company_data?.data?.razao_social} </span>
            no mercado de licitações
          </h5>

          <p className="text-muted fs-5">
            Acesse as ferramentas <a href="/boletim_web/public/boletins">Boletins</a> e{' '}
            <a href="/banco_de_dados">Encontrar Licitações</a> para descobrir oportunidades e
            iniciar suas vendas para o governo.
          </p>
          <a href="/painel" className="btn btn-outline-primary">
            PAINEL
          </a>
        </div>
      </Modal>
    </Container>
  );
};

export default MyHistoryModal;
